import React, { useEffect, useRef, useState } from 'react'

import {ReactComponent as IconArrowDown} from '../../assets/icons/ic-arrow-down-gray.svg'
import {ReactComponent as IconArrowUp} from '../../assets/icons/ic-arrow-up-gray.svg'
import {ReactComponent as IconCheckBlue} from '../../assets/icons/ic-check-blue.svg'

const Dropdown = ({ type, isShow, isUpSide, isNumeric, value, valueArr, selectedParameters, handleClick, handleValueClick }) => {
    const openRef = useRef(null)
    const dropdownRef = useRef(null)
    const [optionList, setOptionList] = useState([])
    const [nowOption, setNowOption] = useState()

    const handleClickOutside = (event) => {
        if (openRef.current && openRef.current.contains(event.target)) {
            return
        }
        if(dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            handleClick(false)
        }
    }

    useEffect(() => {                
        const codeSet = new Set(selectedParameters.map(item => item.measureParameterId));
        const codeList = valueArr.filter(item => {
            if(value === item.id){
                setNowOption(item.parameter);
            }           
            return item.parameter === "NONE" || value === item.id || !codeSet.has(item.id);            
        })
        .sort((a, b) => a.parameter.localeCompare(b.parameter));        
        setOptionList(codeList);
    }, [selectedParameters])

    useEffect(() => {
        window.addEventListener('mousedown', handleClickOutside);
    }, [])

    return (
        <div ref={openRef} className="relative flex items-center mr-2 cursor-pointer" onClick={() => { handleClick() }} style={{ padding: '7px 8px', width: isNumeric ? 212 : 192, height: 32, borderRadius: 6, border: '1px solid #CECECE', background: 'white'}}>
            <span className="" style={{ fontWeight: 300 }}>{ nowOption }</span>
            <div className="ml-auto flex">
                {
                    isShow ? <IconArrowUp /> : <IconArrowDown />
                }
            </div>
            {
                isShow &&
                <div ref={dropdownRef} className="absolute bg-white rounded-[6px] scrollbar scrollbar--gray" style={{ maxHeight: 200, width: isNumeric ? 212 : 192, top: isUpSide ? (valueArr.length * -32 - 23) : 32, left: 0, zIndex: 9999, padding: '8px 0', border: '1px solid #5E5E5E', boxShadow: '0px 12px 12px 0px #00000099' }}>
                    {
                        optionList.map((item, idx) => {
                            return (
                                <div 
                                    onClick={() => { handleValueClick(item) }}
                                    className="flex items-center px-2 room-list-item"
                                    key={`dropdown-list-item-${type}-${idx}`}
                                    style={{ height: 32, color: item.id === value ? '#3182F7' : '', fontWeight: 300 }}>
                                    { item.parameter }
                                    {
                                        item.id === value &&
                                        <IconCheckBlue className="ml-auto"/>
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            }
        </div>
    )
}

export default Dropdown